'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { useRouter } from 'next/navigation';

import { useSupportContact } from '@eliadmin/core/src/components/dlz/auth/dialog/support-contact';
import { PageAuthNavigation } from '@eliadmin/core/src/components/dlz/auth/page/page-auth-navigation';
import {
  PasswordResetCard,
  type PasswordResetStep,
} from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-dialog';
import { DialogOverlay } from '@eliadmin/core/src/components/dlz/dialogs/dialog-overlay';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

/**
 * The forgotten-password dialog over the sign-in page (Figma „MOD – Zabudnuté heslo“, 60155:20067 and
 * 60158:20811), open from the first render on the password-reset URLs; closing it and every exit
 * link lead back to the sign-in page.
 */
export function ResetRouteDialog({
  step,
  email,
  token,
}: {
  step: PasswordResetStep;
  email?: string;
  token?: string;
}) {
  const router = useRouter();
  const support = useSupportContact();

  return (
    <PageAuthNavigation>
      <Dialog.Root open onOpenChange={open => !open && router.push(ROUTES.SIGN_IN())}>
        <Dialog.Portal>
          <DialogOverlay />
          <PasswordResetCard initialStep={step} email={email} token={token} {...support} />
        </Dialog.Portal>
      </Dialog.Root>
    </PageAuthNavigation>
  );
}
